import React, { Component } from 'react'

import Auth from 'j-toker'
import { LogIn, Plus, Search, User } from 'react-feather'
import { withRouter } from 'react-router'
import {
  Link,
  NavLink,
} from 'react-router-dom'
import MediaQuery from 'react-responsive';

import { formatNotificationCountAsReasonable } from '../../utilities/formatters'
import { fetchUnreadNotificationsCountCurrent } from '../../utilities/notifications'

import HeaderLogin from './header-login'
import HeaderSearch from './header-search'
import AlertNotification from '../alerts/alert-notification'
import Logo from '../images/pc-logo.svg'

class HeaderSite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unread_notifications_count: 0,
      destination: '',
      is_login: false,
      is_search: false,
      is_scrolling: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('toggleLogin', this.onToggleLogin);
    window.addEventListener('toggleSearch', this.onToggleSearch);
    if (Auth.user.signedIn) {
      this.attemptUpdateNotificationCount();
    }
  }

  componentDidUpdate(prevProps) {
    if (Auth.user.signedIn && (this.props.location !== prevProps.location)) {
      this.attemptUpdateNotificationCount()
      this.setState({
        destination: ''
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('toggleLogin', this.onToggleLogin);
    window.removeEventListener('toggleSearch', this.onToggleSearch);
  }

  attemptUpdateNotificationCount() {
    if(window.location.pathname != '/account/notifications') {
      fetchUnreadNotificationsCountCurrent()
      .then((data) => {
        this.setState({
          unread_notifications_count: data.unread_notifications_count
        })
      })
    } else {
      this.setState({
        unread_notifications_count: 0
      })
    }
  }

  onScroll = (e) => {
    this.setState({
      is_scrolling: window.scrollY > 10
    });
  }

  onToggleSearch = (e) => {
    e.preventDefault();
    let stateChange = {};
    stateChange['is_search'] = !this.state.is_search;
    this.setState(stateChange);
  }

  onToggleLogin = (e) => {
    e.preventDefault();
    let stateChange = {};
    stateChange['is_login'] = !this.state.is_login;
    if(e.detail && e.detail.destination) {
      console.log(e.detail.destination);
      stateChange['destination'] = encodeURIComponent(e.detail.destination);
    }
    this.setState(stateChange);
  }

  onToggleLoginFromNewStory = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('toggleLogin', {
      detail: {
        destination: `/stories/new`
      }
    }));
  }

  setStoriesLinkActive = (match, location) => {
    return (match.url === location.pathname) || location.pathname.includes('/stories') || location.pathname.includes('/newest') || location.pathname.includes('/badges');
  }

  render() {
    return (
      <header className={`header header--site ${this.state.is_scrolling ? 'header--scroll' : ''}`}>
        <nav className="nav nav--site">
          <Link className="link--nav link--logo" to={`/`}><img className="media--logo" src={Logo} /></Link>
          <NavLink className="link--nav" activeClassName="link--active" isActive={this.setStoriesLinkActive} to={`/`}>Stories</NavLink>
          <NavLink className="link--nav" activeClassName="link--active" to={`/shows`}>Shows</NavLink>
          <NavLink className="link--nav" activeClassName="link--active" to={`/jobs`}>Jobs</NavLink>
{/*
          <MediaQuery query="(max-width: 479px)">
            <button className="link--nav link-nav--lowlight" onClick={this.onToggleSearch}><Search /></button>
          </MediaQuery>
          <MediaQuery query="(min-width: 480px)">
            <button className="link--nav" onClick={this.onToggleSearch}><Search /></button>
          </MediaQuery> */}

          <MediaQuery query="(max-width: 479px)">
            {!Auth.user.signedIn ?
              <button className="link--nav link-nav--lowlight" onClick={this.onToggleLogin}>
                <LogIn />
              </button> :
              <figure className="link--nav link--dual">
                <Link className="link--nav link-nav--lowlight" to={`/account`}><User /></Link>
                {this.state.unread_notifications_count > 0 && <AlertNotification>{formatNotificationCountAsReasonable(this.state.unread_notifications_count)}</AlertNotification>}
              </figure>
            }
          </MediaQuery>
          <MediaQuery query="(min-width: 480px)">
            {!Auth.user.signedIn ?
              <button className="link--nav" onClick={this.onToggleLogin}>
                  <span>Log in</span>
                  <span className="text--spacer">•</span>
                  <span>Register</span>
              </button> :
              <figure className="link--nav link--dual">
                <NavLink activeClassName="link--active" className="link--nav" to={`/account`}>
                  <span>{(Auth.user.name).split(' ')[0]}</span>
                </NavLink>
                {this.state.unread_notifications_count > 0 && <AlertNotification>{formatNotificationCountAsReasonable(this.state.unread_notifications_count)}</AlertNotification>}
              </figure>

            }
          </MediaQuery>

          {!Auth.user.signedIn ?
            <button className="link--nav link--nav-highlight" onClick={this.onToggleLoginFromNewStory}>
              <MediaQuery query="(max-width: 479px)">
                <Plus />
              </MediaQuery>
              <MediaQuery query="(min-width: 480px)">
                <span>New Story</span>
              </MediaQuery>
            </button> :

            <Link className="link--nav link--nav-highlight" to={`/stories/new`}>
              <MediaQuery query="(max-width: 479px)">
                <Plus />
              </MediaQuery>
              <MediaQuery query="(min-width: 480px)">
                <span>New Story</span>
              </MediaQuery>
            </Link>
          }
        </nav>
        {this.state.is_login && <HeaderLogin onToggleLogin={this.onToggleLogin} destination={this.state.destination}/>}
        {this.state.is_search && <HeaderSearch />}
      </header>
    );
  }
}

export default withRouter(HeaderSite);



// WEBPACK FOOTER //
// ./src/app/components/headers/header-site.jsx